<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
          >
            <div slot="header">
              <span data-font="20">Inventory</span>
            </div>
            <div slot="header">
              <b-button
                @click="$router.push({ path: '/faqdetails' })"
                style="font-size: 20px"
                variant="primary"
                class="float-right"
                >Help</b-button
              >
            </div>
            <b-tabs v-model="tabIndex">
              <b-tab title="Select Delivery Centre">
                <inventory-report></inventory-report>
              </b-tab>
              <b-tab title="Item Details">
                <item-details></item-details>
              </b-tab>
              <b-tab title="Load Inventory">
                <loadinventory></loadinventory>
              </b-tab>
              <b-tab title="Update Inventory">
                <updateinventory></updateinventory>
              </b-tab>
              <b-tab title="Transfer Inventory">
                <transferinventory></transferinventory>
              </b-tab>
              <b-tab title="Upload History" :title-item-class="'uploadHistory'">
                <inventoryResults></inventoryResults>
              </b-tab>
            </b-tabs>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cTable from "../base/Table.vue";
import { mapState, mapActions } from "vuex";
import { AtomSpinner } from "epic-spinners";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import ItemDetails from "./ItemDetails.vue";
import loadinventory from "./LoadInventory.vue";
import updateinventory from "./UpdateInventory.vue";
import transferinventory from "./TransferInventory.vue";
import inventoryResults from "./InventoryUpdateHistory.vue";
import InventoryReport from "./InventoryReport.vue";

export default {
  name: "Inventory",
  components: {
    cTable,
    AtomSpinner,
    "item-details": ItemDetails,
    loadinventory,
    updateinventory,
    transferinventory,
    inventoryResults,
    "inventory-report": InventoryReport,
  },
  data: () => {
    return {
      tabIndex: 0,
      transProps: {
        name: "flip-list",
      },
      showDismissibleAlert: false,
      loading: false,
      items: [],
      catalogSelectedID: "1",
      provider: "",
      catalogList: [
        {
          text: "Select Catalog",
          value: "1",
        },
      ],
      fields: [],
      filter: "",
      caption: "Table",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      tableData: [],
      perPage: 5,
      pageOptions: [5, 10, 15, 20, 25, 30],
      currentPage: 1,
      dark: false,
    };
  },
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
    }),
  },
  mounted: async function () {
    this.provider = this.$store.getters["auth/getUserID"];
    this.GetStockpoints();
  },
  computed: {
    ...mapState("auth", ["permissions"]),
    totalRows() {
      return this.items.length;
    },
    captions() {
      return this.fields;
    },
  },
};
</script>

<style>
.mymodalclass > div {
  margin-top: 45px !important;
}
.text-center {
  text-align: center !important;
}
[data-font="20"] {
  font-size: 20px;
}
.edit {
  color: #ffffff !important;
}
.bin {
  color: white !important;
}

table.table-bordered > tbody > tr {
  /* text-transform: capitalize; */
  text-align: center;
}
table#table-transition-example .flip-list-move {
  transition: transform 1s;
}
</style>
